import { ExternalLinkProps } from '@styles/shared-styles';
import { AnchorHTMLAttributes } from 'react';

export enum SecureExternalLinksErrors {
    UNSAFE_LINK = 'Unsafe external link'
}

type AnchorAttributes = AnchorHTMLAttributes<HTMLAnchorElement>;
export const secureExternalLinkProps = (props: AnchorAttributes & ExternalLinkProps): AnchorAttributes => {
    const {
        isolateLink = true,
        href,
        target
    } = props;

    if (!isolateLink && target === '_blank') {
        throw new Error(SecureExternalLinksErrors.UNSAFE_LINK);
    }

    const rel = isolateLink === true ? 'noopener noreferrer' : undefined;
    return {
        rel,
        href: href ?? '#'
    };
};



// WEBPACK FOOTER //
// ./src/utils/secure-links.ts